// Accounts Exports grants — its own file so a SOURCE module's list (which adds
// the "Create Export Batch" action) does not pull this module's route shell
// into its chunk (BP-06).
import { useEffect, useState } from "react";

import { useConfig } from "../hooks/useConfig";
import { useCurrentUser } from "../hooks/useCurrentUser";

/** The nav row's mod_function: the key of the user's permission bag. */
export const MOD_FUNCTION = "batchexports";
/** The config rows holding the permission ids: legacy `myob_import_create` / `myob_import_Edit`. */
export const CONFIG_FUNCTION = "myob_import";

/**
 * Per-user grants, FAIL CLOSED: an unloaded config or an absent bag entry is a
 * deny (Blank's index.tsx: "A real module deletes the fallback"). The token
 * case is the live one — `create` lower, `Edit` capitalised (module_g2_demo
 * config 1801 / 1802) — and useConfig strips the `myob_import_` prefix.
 */
export function useBatchExportGrants() {
  const currentUser = useCurrentUser();
  const config = useConfig(CONFIG_FUNCTION) as Record<string, unknown> | undefined;

  const [canCreate, setCanCreate] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    if (!config || !currentUser) return;
    const bag = (currentUser.permissions as Record<string, Array<number | string>> | undefined)?.[MOD_FUNCTION] ?? [];
    const holds = (token: unknown) =>
      token != null && token !== "" && bag.some((p) => Number(p) === Number(token));
    setCanCreate(holds(config.create));
    setCanEdit(holds(config.Edit));
  }, [currentUser, config]);

  return { canCreate, canEdit };
}
